import React, { useEffect, useState } from 'react';
import DENTModalOverviewSubButtonsSelection from '../DENTModalOverviewSubButtonsSelection/DENTModalOverviewSubButtonsSelection';
import {
	ToothDiscolorationType,
	ToothPathologyDiscolorationValues,
} from '../../../../graphql/graphql';
import useTooth from '../../Hooks/Tooth/useTooth';

const DENTModalOverviewPathologyDiscoloration = () => {
	const {
		pathology: { discoloration },
	} = useTooth();

	const [values, setValues] = useState<
		ToothPathologyDiscolorationValues | undefined
	>(discoloration.values);

	useEffect(() => {
		if (values) discoloration.setValues(values);
	}, [values]);

	const handleChangeType = (value: ToothDiscolorationType) =>
		setValues(prev => ({
			...prev,
			type: prev?.type === value ? undefined : value,
		}));

	const rows = [
		{
			shouldHide: false,
			items: [
				{
					title:
						'patientTreatment.meddiDENT.dentalCross.pathologyModal.discoloration.gray',
					isSelected: values?.type === ToothDiscolorationType.Gray,
					onClick: () => handleChangeType(ToothDiscolorationType.Gray),
				},
				{
					title:
						'patientTreatment.meddiDENT.dentalCross.pathologyModal.discoloration.red',
					isSelected: values?.type === ToothDiscolorationType.Red,
					onClick: () => handleChangeType(ToothDiscolorationType.Red),
				},
				{
					title:
						'patientTreatment.meddiDENT.dentalCross.pathologyModal.discoloration.yellow',
					isSelected: values?.type === ToothDiscolorationType.Yellow,
					onClick: () => handleChangeType(ToothDiscolorationType.Yellow),
				},
			],
		},
	];

	return <DENTModalOverviewSubButtonsSelection rows={rows} />;
};

export default DENTModalOverviewPathologyDiscoloration;
